'use strict'

fetchUser =

  getLsAuthCookie: ->
    Groupon.endpoints?.token_exchange and not Cookie.get('snickerdoodle')

  # call /token_exchange api if it needs to exchange token
  # @param {Function} callback - The callback which is called after exchanged token
  exchangeTokenIfNeed: (callback) ->
    # only if there is a cookie item named ls-auth
    # and it's livingsocial
    if not @getLsAuthCookie()
      callback()
      return

    $.ajax {
      type: 'GET'
      url: Groupon.endpoints?.token_exchange
      timeout: 5000
      complete: callback
    }


  ###*
  # Fetch user data from endpoint
  #
  # @param {String}   userId  - User snickerdoodle id
  # @param {Function} success - Success callback
  # @param {Function} [error] - Error callback (Optional)
  ###
  fetch: (userId, success, error) ->
    userId = userId?.replace(/"/g, '')

    $.ajax {
      type: 'GET'
      url: [ Groupon.endpoints?.users, 'v1'].join '/'
      headers: { 'x-ls-locale': I18n.locale }
      timeout: 5000
      success: (res) ->
        {data: user, err} = res
        return error(err) if err
        return error('No user info') if not user
        try
          sessionStorage?.setItem('verifiedUser', JSON.stringify(user))
        success(user)
      error: error
    }
    return

  ###
  # Removes user data from browser sessionStorage
  ###
  removeUserData: ->
    try
      sessionStorage?.removeItem('verifiedUser')
    return

  ###*
  # @typedef  {Object}  userObject
  # @property {Boolean} hasUserData - Flag indicating that user data is stored
  # @property {String}  userId      - Snickerdoodle id
  ###

  ###*
  # Check for user data from Browser sessionStorage and process data if available
  #
  # @param   {Function} [noUser_cb]    - Callback executed when user is logged out (Optional)
  # @param   {Function} [hasUser_cb]   - Callback executed when user is logged in (Optional)
  # @returns {Object}   userObject
  ###
  useStoredData: (noUser_cb, hasUser_cb) ->
    userId = Cookie.get('snickerdoodle')?.replace(/"/g, '')
    hasUserData = false

    # don't make the API call if there's no snickerdoodle
    # cookie (the logged out view is already rendered)
    if not userId
      @removeUserData()
      noUser_cb() if noUser_cb
    else
      if (data = sessionStorage?.getItem('verifiedUser'))?
        try
          user = JSON.parse(data)

        if user and typeof user is 'object'
          hasUser_cb(user) if hasUser_cb
          hasUserData = true

    return {
      hasUserData
      userId
    }

module.exports = {
  fetchUser
}
